// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

Vue.config.productionTip = process.env.NODE_ENV === 'production'
Vue.config.ENV = process.env.NODE_ENV
Vue.config.CURRENCY_SERVICE_BASE_URL = process.env.CURRENCY_SERVICE_BASE_URL
Vue.config.WS_SERVICE_BASE_URL = process.env.WS_SERVICE_BASE_URL
Vue.config.CURRENCY_SERVICE_ROOT_BASE_URL = process.env.CURRENCY_SERVICE_ROOT_BASE_URL
Vue.config.PAYPAL_CLIENT_ID = process.env.PAYPAL_CLIENT_ID
Vue.config.ITEM_ASSET_BASE_URL = process.env.ITEM_ASSET_BASE_URL
Vue.config.WEB_ASSET_BASE_URL = process.env.WEB_ASSET_BASE_URL
Vue.config.ROOM_JS_URL = process.env.ROOM_JS_URL

// console.log('PROCESS', Vue.config.WS_SERVICE_BASE_URL)

import './assets/theme.css'
import App from './App'
import router from './router'
import Bet from './components/Bet'
import TicketRaffle from './components/Ticket-Raffle'
import TicketRaffleEntries from './components/Ticket-Raffle-Entries'
import PlacedBets from './components/Placed-Bets'
import User from './components/User'
import DebugPanel from './components/Debug-Panel'
import LoginBtn from './components/Login-Btn'
import DiscordBtn from './components/Discord-Btn'
import LoginStatus from './components/Login-Status'
import ButtonA from './components/button_a'
import NavBar from './components/Navigation-Bar'
import HeaderTitle from './components/Header-Title'
import InfoBox from './components/Info-Box'
import mixins from './lib/util.js'
import Vuex from 'vuex'
import store from './store'
import VueGtag from 'vue-gtag'
import VueUploadComponent from 'vue-upload-component'

// config: { id: 'UA-177228719-1' }
Vue.use(VueGtag, {
  config: { id: 'G-FZDEQXC5WP' }
}, router)

store.connect()

Vue.use(Vuex)

Vue.component('file-upload', VueUploadComponent)

Vue.component('Bet', Bet)
Vue.component('placed-bets', PlacedBets)
Vue.component('login-btn', LoginBtn)
Vue.component('discord-btn', DiscordBtn)
Vue.component('login-status', LoginStatus)
Vue.component('ticket-raffle', TicketRaffle)
Vue.component('ticket-raffle-entries', TicketRaffleEntries)
Vue.component('button-a', ButtonA)
Vue.component('nav-bar', NavBar)
Vue.component('header-title', HeaderTitle)
Vue.component('info-box', InfoBox)
Vue.component('User', User)
Vue.component('debug-panel', DebugPanel)
Vue.mixin(mixins)

// console.log('mixins', mixins)

/* eslint-disable no-new */
window.App = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  mixins: [mixins]
})



// WEBPACK FOOTER //
// ./src/main.js